<field-date-readonly *ngIf="field.readonly; else editable" [field]="field"></field-date-readonly>
<ng-template #editable>
  <field-date-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-date-single>
</ng-template>
